export enum UiAlpha {
  Subtle = 0.05,
  Tint = 0.15,
}
